import React, { useEffect, useRef, useState } from 'react';

const Team = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const teamMembers = [
    {
      id: 1,
      name: 'YellowPanther',
      role: 'CEO & Founder',
      bio: 'PLACEHOLDER',
      image: '/team/yp2.png',
      social: {
        twitter: 'https://x.com/yellowpantherx'
      }
    },
    {
      id: 2,
      name: 'Shaun',
      role: 'Chief Business Development Officer',
      bio: 'PLACEHOLDER',
      image: '/team/shaun.jpg',
      social: {
        twitter: 'https://x.com/shaun0x'
      }
    },
    {
      id: 3,
      name: '0xKAI',
      role: 'Chief Operating Officer',
      bio: 'PLACEHOLDER',
      image: '/team/kai.jpg',
      social: {
        twitter: 'https://x.com/0xkai_'
      }
    },
    {
      id: 4,
      name: 'solito',
      role: 'Operations/BD',
      bio: 'PLACEHOLDER',
      image: '/team/solito.jpg',
      social: {
        twitter: 'https://x.com/0xsolito'
      }
    }
  ];

  return (
    <section id="team" className={`team-experimental ${isVisible ? 'section-visible' : ''}`} ref={sectionRef}>
      <div className="container">
        <div className="section-header-experimental">
          <div className="header-decoration">
            <div className="decoration-line"></div>
            <h2>Meet Our Team</h2>
            <div className="decoration-line"></div>
          </div>
          <p>Industry veterans and gaming enthusiasts dedicated to making your game a success.</p>
        </div>

        <div className="team-grid-experimental">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className={`team-card-experimental ${isVisible ? 'card-visible' : ''}`}
            >
              <div className="card-border"></div>
              <div className="card-corner top-left"></div>
              <div className="card-corner top-right"></div>
              <div className="card-corner bottom-left"></div>
              <div className="card-corner bottom-right"></div>

              <div className="team-image-experimental">
                <img src={member.image} alt={member.name} />
                <div className="team-overlay-experimental">
                  <div className="social-links">
                    <a
                      href={member.social.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                      aria-label={`${member.name} Twitter`}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              <div className="team-content-experimental" style={{ padding: '2rem' }}>
                <h3 className="team-name-experimental">{member.name}</h3>
                <div className="title-underline"></div>
                <p className="team-role-experimental">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;